/**
 * Firebase Analytics Event Names
 *
 * Guidelines:
 * - Use lowercase with underscores (Firebase convention)
 * - Keep names descriptive and consistent
 * - Document what each event tracks
 */

export const SCREEN_NAMES = {
  AUTH: 'shared_pmn_auth_screen',
  HOME: 'shared_pmn_home_screen',
  MARKET_REPORT: 'shared_pmn_market_report_screen',
  POTITTO_AI: 'shared_pmn_potitto_ai_screen',
  MANSION_ASSESSMENT: 'shared_pmn_mansion_assessment_screen',
  HELPFUL_TOOLS: 'helpful_tools_screen',
  HELPFUL_TOOLS_DETAIL: 'helpful_tools_detail_screen',
  PRIVILEGED_MEMBER_HELPFUL_TOOLS: 'privileged_member_helpful_tools_screen',
  PRIVILEGED_MEMBER_HELPFUL_TOOLS_DETAIL: 'privileged_member_helpful_tools_detail_screen',
  PRIVILEGED_MEMBER_TERMS_OF_SERVICE: 'privileged_member_terms_of_service_screen',
  PRIVILEGED_MEMBER_PRIVACY_POLICY: 'privileged_member_privacy_policy_screen',
  MANSION_VIDEO_SHARE: 'mansion_video_share_screen',
};

// Button Names
export const BUTTON_NAMES = {
  MARKET_REPORT: 'shared_pmn_market_report_tap',
  POTITTO_AI: 'shared_pmn_potitto_ai_tap',
  MANSION_ASSESSMENT: 'shared_pmn_mansion_assessment_tap',
  AUTH_SUBMIT: 'shared_pmn_auth_submit_tap',
  BACK_TO_HOME: 'shared_pmn_back_to_home_tap',
};

/*
略語説明
pmn = project_management_note
 */